module.exports = __webpack_public_path__ + "static/media/waterdamage.6c777d96.jpg";